<template>
  <div class="g-content">
    <div class="message-wrapper">
      <!-- 左侧消息分类 -->
      <div class="message-slider">
        <div class="message-slider-content">
          <div class="message-slider-header flex-space-between">
            <div>
              {{ $t('message_center') }}
            </div>
            <div>
              <Icon
                type="refresh"
                class="refresh-btn"
                :class="{ 'refresh-loading': refreshLoading }"
                @click.native.stop="handleRefresh"
              />
              <a-icon type="setting" @click="toSetting" v-if="AUTH_MESSAGE_SETTING" />
            </div>
          </div>

          <!-- 左侧搜索 -->
          <div class="message-slider-search">
            <a-input-search
              :placeholder="$t('com_form_keyword_input')"
              allowClear
              @search="
                value => {
                  if (value) {
                    this.$refs.searchDialog.open(value);
                  }
                }
              "
              enter-button
              ref="searchInput"
            />
          </div>

          <div class="flex-space-between message-nav-list-top">
            <!-- 未读消息总数 -->
            <div class="total">
              {{ $t('message_all') }}
              <span v-if="messageUnreadNum > 0"
                >(<span class="number">{{
                  $t('message_unread', [messageUnreadNum > 99 ? '99+' : messageUnreadNum])
                }}</span
                >)</span
              >
            </div>
            <!-- 清除消息 -->
            <div class="clear-btn" @click.stop="clearUnread" v-if="AUTH_MESSAGE_CLEAR_UNREAD">
              <Icon type="delete" class="del-icon" />
              {{ $t('message_clear_unread') }}
            </div>
          </div>

          <!-- 左侧分类列表 -->
          <CategoryList
            :categoryData="categoryData.categories"
            :currentCategory="currentCategory"
            :clickEvent="categoryClick"
            v-if="categoryData"
          />
        </div>
      </div>

      <!-- 右侧消息列表 -->
      <div class="message-content">
        <div class="message-content-container">
          <!-- 当前分类有才显示，没有显示无数据 -->
          <div v-if="currentCategory">
            <Loading :show="true" v-if="loading" />

            <div class="message-content-list" v-else>
              <div class="message-header flex-space-between">
                <!-- 当前分类标题 -->
                <div class="total" v-if="currentCategory">
                  {{ currentCategory.name }}
                </div>

                <!-- 维护通知类型才显示“一键处理”（一键处理跟移动端保持一致） -->
                <div
                  class="clear-btn"
                  @click.stop="handleAll"
                  v-if="
                    currentCategory?.type === 4 &&
                      smsList.length > 0 &&
                      unhandleNum &&
                      unhandleNum > 0
                  "
                >
                  <a-icon type="check-circle" theme="filled" />
                  {{ $t('message_processed_all') }}
                </div>
              </div>

              <div v-if="smsList && smsList.length > 0">
                <MessageItem
                  :msg="msg"
                  :currentCategory="currentCategory"
                  :callback="
                    () => {
                      // 重新获取列表
                      getCategoryList();
                    }
                  "
                  v-for="msg in smsList"
                  :key="msg.id"
                />

                <div class="pagination">
                  <Pagination
                    :current.sync="categoryPage[currentCategory.id].pageNo"
                    :total="categoryPage[currentCategory.id].total"
                    :pageSize.sync="pagination.pageSize"
                    :callback="pageChange"
                    @change="pageChange"
                    :showSizeChanger="true"
                    v-if="currentCategory && categoryPage[currentCategory.id]"
                  />
                </div>
              </div>
              <Empty v-else style="padding:100px 0;" />
            </div>
          </div>

          <!-- 无数据 -->
          <Empty v-else />
        </div>
      </div>
    </div>

    <!-- 搜索 -->
    <Search ref="searchDialog" />
  </div>
</template>
<script>
import * as API from '@/api/message';
import { mapState } from 'vuex';
import Search from './components/search.vue';
import messageMixins from '@/views/message/mixins';
import MessageItem from './components/messageItem.vue';
import CategoryList from './components/categoryList.vue';
import messageAuth from '@/views/message/mixins/messageAuth';

export default {
  mixins: [messageMixins, messageAuth],
  components: {
    Search,
    MessageItem,
    CategoryList,
  },
  data() {
    return {
      // 轮询定时器
      pollingTimer: null,
      // 右侧列表加载中
      loading: true,

      // 当前选中消息分类
      currentCategory: null,
      categoryData: null,

      // 右侧列表数据
      smsList: null,

      refreshLoading: false,

      // 刷新动画最小时间
      minAnimationDuration: 1000,

      // 分页
      pagination: {
        // 每页显示
        pageSize: 10,
      },
      categoryPage: {},

      // 轮询时间 15s
      pollingTime: 15 * 1000,

      unhandleNum: null,
    };
  },
  computed: {
    ...mapState(['messagePollingTime', 'messageUnreadNum']),
    // 是否是系统消息
    isSystemMessage() {
      return this.currentCategory?.type == 0;
    },
  },
  created() {
    this.getCategoryList();
  },
  beforeDestroy() {
    this.clearPolling();
  },
  methods: {
    // 分类点击
    categoryClick(item) {
      this.setCurrent(item);
      this.getMessageList('click');
      // 每次点击分类时会清楚未读消息，所以这里要调用一下分类接口
      this.getCategoryList();
    },

    // 获取左侧分类列表
    getCategoryList(refresh, callback) {
      return API.getCategoryList()
        .then(res => {
          if (res.code === 0) {
            this.categoryData = res.data || {};
            // 暂存消息未读数量到 store ，保持 header的显示数量跟当前一至
            this.$store.commit('setMessageUnreadNum', this.categoryData.unReadCount);

            // 初始化各个分类的页码配置
            this.categoryData.categories.forEach(item => {
              // 如果没有就初始化
              if (!this.categoryPage[item.id]) {
                this.categoryPage[item.id] = {
                  pageNo: 1,
                  total: 0,
                };
              }
            });

            // 默认第一个
            if (!this.currentCategory) {
              this.currentCategory = this.categoryData.categories[0];
            }

            // 获取右侧消息列表
            // 刷新的时候不用调右边的列表
            if (this.currentCategory && refresh !== true) {
              this.getMessageList(refresh);
            }

            callback && callback();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 获取右侧消息列表
    getMessageList(refresh) {
      this.loading = true;

      // pageNo
      let pageNo = 1;
      if (this.categoryPage[this.currentCategory.id]) {
        pageNo = this.categoryPage[this.currentCategory.id].pageNo;
      }
      const methods = this.isSystemMessage ? 'getSysmsg' : 'getDevmsg';
      const msgParams = {
        categoryId: this.currentCategory.id,
        categoryType: this.currentCategory.type,
        pageNo: pageNo,
        pageSize: this.pagination.pageSize,
      };

      return API[methods](msgParams)
        .then(res => {
          if (res.code === 0) {
            this.smsList = res.data || [];

            // 更新当前分类的总数
            if (this.categoryPage[this.currentCategory.id]) {
              this.categoryPage[this.currentCategory.id].pageNo = pageNo;
              this.categoryPage[this.currentCategory.id].total = res.totalCount || 0;
            }

            // 获取维护消息的unhandle
            if (this.currentCategory.type === 4) {
              this.getUnhandleNum();
            }

            // 清除未读消息(只有单击的时候才清除未读)
            if (this.currentCategory && refresh === 'click' && this.smsList.length) {
              API.clearCategoryUnread({
                categoryId: this.currentCategory.id,
              }).then(res => {
                if (res.code === 0) {
                  // 仅仅刷新分类
                  this.getCategoryList(true);
                }
              });
            }
          }
        })
        .finally(() => {
          this.loading = false;
          this.$store.commit('setPageLoading', false);

          // 启动轮询
          this.clearPolling();
          this.pollingTimer = setTimeout(() => {
            this.getCategoryList('polling');
          }, this.messagePollingTime);
        });
    },

    getUnhandleNum() {
      API.unhandleNum().then(res => {
        if (res && res.code === 0) {
          this.unhandleNum = res.data || 0;
        }
      });
    },

    setCurrent(item) {
      this.currentCategory = item || {};
    },

    // 跳转消息接收管理
    toSetting() {
      this.$router.push({ name: 'MessageSetting' });
    },

    // 清除未读
    clearUnread() {
      this.$confirm({
        title: this.$t('message_confirm_clear_unread_content'),
        centered: true,
        onOk: () => {
          this.deleteLoading = true;
          this.$store.commit('setFreeze', this.$t('message_handle_loading'));
          API.changeunread()
            .then(res => {
              if (res.code === 0) {
                this.$message.success(this.$t('com_msg_success'));
                // 重新获取列表
                this.getCategoryList();
              }
            })
            .finally(() => {
              this.$store.commit('setFreeze', false);
            });
        },
      });
    },

    // 全部处理
    handleAll() {
      this.$confirm({
        title: this.$t('message_confirm_handle_all_content'),
        content: this.$t('device_confirm_maintain_content3'),
        centered: true,
        onOk: () => {
          this.deleteLoading = true;
          this.$store.commit('setFreeze', this.$t('com_table_loading'));
          API.handleMtall({ id: this.currentCategory.id })
            .then(res => {
              if (res.code === 0) {
                this.$message.success(this.$t('com_msg_success'));
                // 重新获取当前列表（右边），左边不用重新获取
                this.getMessageList();

                this.getUnhandleNum();
              }
            })
            .finally(() => {
              this.$store.commit('setFreeze', false);
            });
        },
      });
    },

    // 清除定时器
    clearPolling() {
      if (this.pollingTimer) {
        clearTimeout(this.pollingTimer);
        this.pollingTimer = null;
      }
    },

    // 处理刷新
    handleRefresh() {
      if (this.refreshLoading) return; // 防止重复点击
      this.refreshLoading = true;

      this.getCategoryList('refresh', () => {
        const startTime = Date.now();
        const elapsedTime = Date.now() - startTime;
        // 如果接口响应时间小于最小动画时间，则等待
        if (elapsedTime < this.minAnimationDuration) {
          setTimeout(() => {
            this.refreshLoading = false;
          }, this.minAnimationDuration - elapsedTime);
        } else {
          this.refreshLoading = false;
        }
      });
    },

    // 分页
    pageChange(page) {
      this.categoryPage[this.currentCategory.id].pageNo = page;
      this.getMessageList();
    },
  },
};
</script>

<style lang="less" scoped>
.message-wrapper {
  display: flex;
  height: 100%;

  .message-slider {
    flex: 0 0 30%;
    height: 100%;
    max-width: 450px;
    background: @g-layout-background;

    .message-slider-content {
      background: #fff;
      padding: 24px;
      border-radius: 12px;
      box-shadow: 0 -12px 0 0 @g-layout-background;
      height: 100%;
      margin-right: 16px;
      overflow-y: auto;
    }
  }

  .message-content {
    flex: 1;
    height: 100%;
    box-shadow: 0 -12px 0 0 @g-layout-background;
    background: @g-layout-background;

    .message-content-container {
      height: 100%;
      overflow: auto;
      background: #fff;
      border-radius: 12px;
      padding: 24px;
    }
  }
}

.flex-space-between {
  display: flex;
  justify-content: space-between;
}

.message-slider {
  .message-slider-header {
    color: #18181a;
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;

    .refresh-btn {
      width: 20px;
      height: 20px;
      font-size: 20px;
      cursor: pointer;
      margin-right: 10px;
      vertical-align: -3px;
      transition: transform 0.3s ease;

      &.refresh-loading {
        animation: rotating 1s linear infinite;
      }
    }
  }

  .message-slider-search {
    margin: 20px 0 15px;
    height: 35px;
  }
}

.message-nav-list-top {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;

  .total {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #18181a;

    .number {
      color: #f5222d;
    }
  }

  .del-icon {
    vertical-align: -2px;
  }
}

.clear-btn {
  color: #a0a0a7;
  font-size: 16px;
  line-height: 24px;
  cursor: pointer;
  font-weight: normal;
}

.message-content-list {
  .message-header {
    color: #18181a;
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
    margin-bottom: 20px;
    padding-bottom: 12px;
  }
}

@keyframes rotating {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
